import React from 'react';
import PropTypes from "prop-types";

const PortfolioDetailsThumb = ({images}) => {
    const getDirectLink = (url) => {
        if (!url) return "https://via.placeholder.com/670x430?text=No+Image";
        if (typeof url !== 'string') return "https://via.placeholder.com/670x430?text=Invalid+Format";

        const match = url.match(/(?:\/d\/|id=)([\w-]+)/);
        const fileId = match ? match[1] : null;

        if (fileId) {
            return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
        }
        return url;
    };

    return (
        <div className="portfolio-details-image mb-sm-30 mb-xs-30">
            {images && images.map((image, index) => {
                const imageUrl = typeof image === 'object' ? image.url : image;
                
                return (
                    <img 
                        key={index} 
                        src={getDirectLink(imageUrl)}
                        alt="portfolio"
                        className="mb-20"
                        style={{ width: '100%', borderRadius: '8px' }}
                    />
                );
            })}
        </div>
    );
};

PortfolioDetailsThumb.prototype = {
    images: PropTypes.array
};

PortfolioDetailsThumb.defaultProps = {
    images: [
        "https://via.placeholder.com/670x430",
        "https://via.placeholder.com/670x430"
    ]
};

export default PortfolioDetailsThumb;